import './styles.scss'

import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'

import playIcon from './_assets/play-icon.svg'

const iframeAllow =
  'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'

const PLACEHOLDER_WIDTH = 120

const NewVideoPlayer = ({ title = '', videoId, closeVideo = () => {}, isVisible = false, withGradient }) => {
  const [isPlaying, setIsPlaying] = useState(false)

  const handlePlay = useCallback(() => setIsPlaying(true), [])

  const handleBackgroundClick = useCallback(
    event => {
      if (event.target === event.currentTarget) closeVideo()
    },
    [closeVideo]
  )
  if (!isVisible) return null

  const handleOnLoad = event => {
    if (event.currentTarget.naturalWidth <= PLACEHOLDER_WIDTH) {
      event.currentTarget.src = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
    }
  }

  return (
    <div className='video-player-container' onClick={handleBackgroundClick}>
      <div className='video-player'>
        {!isPlaying ? (
          <>
            <img
              src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
              alt='Video thumbnail'
              className='thumbnail'
              onLoad={handleOnLoad}
            />
            <div className='overlay' onClick={handlePlay}>
              <img className='play-icon' src={`${playIcon}`} alt='Play icon' width={64} height={64} />
              {title && <div className='title'>{I18n.t('courses.show.video_title', { title })}</div>}
            </div>
          </>
        ) : (
          <iframe
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&showinfo=0&autohide=1&iv_load_policy=3&theme=dark&color=white`}
            title={title}
            className='iframe'
            allow={iframeAllow}
            allowFullScreen
          />
        )}
      </div>
      {withGradient && !isPlaying && <div className='gradient-overlay' id='gradientOverlay' />}
    </div>
  )
}

NewVideoPlayer.propTypes = {
  isVisible: PropTypes.bool,
  closeVideo: PropTypes.func,
  videoId: PropTypes.string,
  title: PropTypes.string,
  withGradient: PropTypes.bool
}

export default NewVideoPlayer
